module.exports = __webpack_public_path__ + "static/media/emika2.97d718b8.jpg";